import { h, Fragment } from 'preact';
import { route } from 'preact-router';
import { createPortal } from 'preact/compat';
import { useEffect } from 'preact/hooks';

import { firebaseLogout } from '../../lib/Firebase';
import UserIcon from '../../molecules/Icon/User';
import ShutdownIcon from '../../molecules/Icon/shutdown';
import Multiply from '../../molecules/Icon/Multiply';
import { getResellerRoute } from '../../lib/ResellerViewAmalgam';
import { RESELLER_TABS } from '../../lib/Utils';
import PoweredByResellship from '../../molecules/PoweredByResellship';
import { getLogoPath } from '../../lib/Company';
import { getGroupRouteSlugs } from '../../lib/GroupCatalogueAmalgam';
import { logoutUser } from '../../lib/Api';
import { onLogout } from '../../lib/Reseller';
import './style.less';

export default ({
  open = false,
  onClose,
  color,
  style,
  companyName,
  companyTag,
  isResellerView,
  renderMenuItems,
  renderSocialLinks
}) => {
  const COLOR = isResellerView ? '#ffffff' : color || '#ffffff';
  const logo = getLogoPath();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const goToProfile = () => {
    const { companySlug, randomSlug } = getGroupRouteSlugs();
    route(`/r/${companySlug}/${randomSlug}/profile`);
  };

  const logout = () => {
    Promise.all([firebaseLogout(), logoutUser()]).then(() => {
      onLogout();
      onClose();
      route(getResellerRoute(RESELLER_TABS.CATALOGUE));
      window.location.reload(true);
    });
  };

  const renderAdditionalMenuItems = () => {
    if (typeof renderMenuItems !== 'function') {
      return null;
    }

    return (
      <ul itemType="http://www.schema.org/SiteNavigationElement" itemScope>
        {renderMenuItems()}
      </ul>
    );
  };

  const renderSocialMediaLinks = () => {
    if (typeof renderSocialLinks !== 'function') {
      return null;
    }

    return renderSocialLinks();
  };

  const renderMenubar = () => (
    <nav className="menu-bar">
      {isResellerView && (
        <button onClick={goToProfile} className="sidebar-common-btn" title="Go to profile page">
          <UserIcon color={COLOR} size="24" viewbox="0 0 24 24" />
          <span>Profile</span>
        </button>
      )}
      {renderAdditionalMenuItems()}
      {isResellerView && (
        <button
          onClick={logout}
          style={{ color: COLOR }}
          className="sidebar-common-btn"
          title="Logout"
        >
          <ShutdownIcon color={COLOR} size="24" viewbox="0 0 56 48" className="icon" />
          <span>Logout</span>
        </button>
      )}
    </nav>
  );

  const socialMediaLinks = renderSocialMediaLinks();

  return createPortal(
    <div
      role="presentation"
      className={`drawer ${open ? 'drawer-open' : 'drawer-closed'} sidebar-menu`}
    >
      <div
        className="drawer-backdrop"
        aria-hidden="true"
        style={{ opacity: open ? 1 : 0 }}
        onClick={onClose}
      />
      <div
        className="drawer-content"
        style={{ transform: open ? 'none' : 'translateX(-100%)', ...style }}
      >
        <button className="closeBtn" onClick={onClose} title="Close side menu">
          <Multiply color={COLOR} size={14} />
        </button>
        <div className="company-profile">
          {isResellerView && (
            <Fragment>
              <img className="logo" src={logo} alt="company logo" height={40} width={40} />
              <div className="title">{companyName}</div>
              <div className="sub-title">{companyTag}</div>
            </Fragment>
          )}
        </div>
        {renderMenubar()}
        {(isResellerView || socialMediaLinks) && (
          <div className="footer">
            {isResellerView && <PoweredByResellship />}
            {socialMediaLinks}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};
